import React, { Component } from "react";
import kycImage from "../assets/image/kyc-verifered.svg";
import feviLogoImage from "../assets/image/fevicol.png";
import FDI_Image from "../assets/image/FDI.png";
import FDI_ICON from "../assets/image/FDI_ICON.png";
import loader from "../assets/image/half-circle.gif";
import { withTranslation } from "react-i18next";
import profileImage from "../assets/image/blank-profile-picture-973460_1280.png";
import ReactStars from "react-rating-stars-component";

// import ReactStars from "react-rating-stars-component";

// const profileRating = {
//     size: 17,
//     count: 5,
//     value: 2.5,
//     isHalf: true,
//     edit: true,
//     emptyIcon: <i className="fa fa-star" />,
//     halfIcon: <i className="fa fa-star-half-alt" />,
//     filledIcon: <i className="fa fa-star" />,
//     color:"#ececec",
//     activeColor:"#FFF700",
// };
const formatDate = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  let dateStr = [day, month, year].join("/");

  return dateStr;
};
class Profile extends Component {
  render() {
    const { data, loading, dataNotFound, ratingData } = this.props;
    const { t } = this.props;
    return (
      <div className="container-left">
        <div className="card card-shadow profile-card">
          {loading ? (
            <div className="card-loader">
              <img src={loader} alt="loading..." />
            </div>
          ) : dataNotFound ? (
            <div className="card-loader">{t("Data not found")}</div>
          ) : (
            <>
              <div className="profile-card-header">
                <div className="profile-image">
                  <figure>
                    {data.profile_image_url ? (
                      <img src={data.profile_image_url} alt="profile" />
                    ) : (
                      <img src={profileImage} alt="profile" />
                    )}
                  </figure>
                </div>
                <div className="profile-content">
                  <div className="d-flex justify-space-between">
                    <div>
                      <h3
                        style={{ display: "inline" }}
                        className="font-20px m-0 profile-name"
                      >
                        {data.name}
                      </h3>
                      {data.digital_batch_c ? (
                        <img className="kycImage" src={kycImage} alt="kyc" />
                      ) : data.kyc_verified ? (
                        <div className="stars profile-content-kyc profile-content-rating-star">
                          <span className="font-10px kyc-text">
                            KYC verified.
                          </span>
                          <img className="kycImage" src={kycImage} alt="kyc" />
                          {/* <input className="star star-5" id="p-star-5" type="radio" name="star"/>
                                        <label className="star star-5" htmlFor="p-star-5"/>
                                        <input className="star star-4" id="p-star-4" type="radio" name="star"/>
                                        <label className="star star-4" htmlFor="p-star-4"/>
                                        <input className="star star-3" id="p-star-3" type="radio" name="star"/>
                                        <label className="star star-3" htmlFor="p-star-3"/>
                                        <input className="star star-2" id="p-star-2" type="radio" name="star"/>
                                        <label className="star star-2" htmlFor="p-star-2"/>
                                        <input className="star star-1" id="p-star-1" type="radio" name="star"/>
                                        <label className="star star-1" htmlFor="p-star-1"/> */}

                          {/* <ReactStars {...profileRating} /> */}
                        </div>
                      ) : null}
                      {ratingData && ratingData.average_rating ? (
                        <div
                          style={{
                            marginTop: -6,
                            marginBottom: -6,
                          }}
                        >
                          <ReactStars
                            size={18}
                            value={
                              ratingData && ratingData.average_rating
                                ? Number(ratingData.average_rating.toFixed(2))
                                : 0
                            }
                            edit={false}
                            isHalf={true}
                            color="#ececec"
                            activeColor=" #FFF700"
                            emptyIcon={<i className="far fa-star"></i>}
                            halfIcon={<i className="fa fa-star-half-alt"></i>}
                            fullIcon={<i className="fa fa-star"></i>}
                            // onChange={this.ratingChanged}
                          />
                          {/* <ReactStars {...writeRivew} /> */}
                        </div>
                      ) : null}

                      <div className="font-10px fcc-text m-t-4px">
                        {t("FCC Membership ID")}
                      </div>
                      <div className="font-13px fcc-id">
                        {data.membership_no}
                      </div>
                      <p className="font-10px fcc-text m-t-4px">
                        <span>{ratingData.total_rating_count}</span> {t("Ratings")} &{" "}
                        <span>{ratingData.total_review_count}</span> {t("Review")}
                      </p>
                      <p className="font-10px fcc-text m-t-4px">
                        {data.current_tier_pc ? (
                          <span>{t("Tier")} : {data.current_tier_pc}</span>
                        ) : null}
                      </p>
                      <p className="font-10px fcc-text m-t-4px">
                        {data.is_a_ob_c && data.ob_designation_c ? (
                          <span>{data.ob_designation_c}</span>
                        ) : null}
                      </p>
                      {data.certificates_details &&
                      data.certificates_details.length ? (
                        <p className="font-10px fcc-text m-t-4px">
                          {" "}
                          {t("Vaccinated")}
                        </p>
                      ) : null}
                    </div>

                    {/* <img
                      className="fevi-logo"
                      src={feviLogoImage}
                      alt="feviLogo"
                    /> */}
                    {data.digital_batch_c ? (
                      <div
                        style={{
                          // width: 100,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <img
                          src={FDI_Image}
                          alt="feviLogo"
                          className="fevi-logo"
                        />
                        <img
                          src={FDI_ICON}
                          alt="feviLogoIcon"
                          style={{
                            height: 40,
                            width: 40,
                            marginLeft: 3,
                            marginRight: 3,
                            marginTop: 0,
                          }}
                        />
                      </div>
                    ) : (
                      <img
                        className="fevi-logo"
                        src={feviLogoImage}
                        alt="feviLogo"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="d-flex profile-details m-t-25px">
                <div className="profile-detail-heading">{t("Mobile")}</div>
                <div className="profile-detail-sepreator">:</div>
                <div className="profile-detail-content">
                  {data.mobile_number}
                </div>
              </div>
              <div className="d-flex profile-details m-t-16px">
                <div className="profile-detail-heading">{t("Email")}</div>
                <div className="profile-detail-sepreator">:</div>
                <div className="profile-detail-content">{data.email}</div>
              </div>
              <div className="d-flex justify-space-between">
                <div className="d-flex profile-details m-t-16px w-45">
                  <div className="profile-detail-heading">{t("Dob")}</div>
                  <div className="profile-detail-sepreator">:</div>
                  <div className="profile-detail-content">
                    {data.dob ? formatDate(data.dob) : " - "}
                  </div>
                </div>
                <div className="d-flex profile-details m-t-16px w-45">
                  <div className="profile-detail-heading">
                    {t("Blood Group")}
                  </div>
                  <div className="profile-detail-sepreator">:</div>
                  <div className="profile-detail-content">
                    {data.blood_group}
                  </div>
                </div>
              </div>
              <div className="m-t-16px">
                <div className="profile-detail-heading font-weight-500 m-r-0 p-b-10px">
                  {t("Address")}
                </div>
                <div className="profile-detail-content line-height-20px">
                  {data.address ? `${data.address},` : null}
                  {data.address ? <br /> : null}
                  {data.street ? `${data.street},` : null}
                  {data.street ? <br /> : null}
                  {data.zipcode ? `${data.city}, ${data.state},` : null}{" "}
                  {data.zipcode}
                </div>
              </div>
              {/* <div className="d-flex m-t-25px">
                        <button className="btn btn-full">SHARE</button>
                    </div> */}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(Profile);
